import { render, staticRenderFns } from "./section-settings-container-fuild.vue?vue&type=template&id=0a2e73bc&scoped=true&"
import script from "./section-settings-container-fuild.vue?vue&type=script&lang=js&"
export * from "./section-settings-container-fuild.vue?vue&type=script&lang=js&"
import style0 from "./section-settings-container-fuild.vue?vue&type=style&index=0&id=0a2e73bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e73bc",
  null
  
)

export default component.exports